module.exports = __webpack_public_path__ + "static/media/HeroFish.58b79541.jpg";